import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Outils de test de sécurité (développement uniquement)
if (process.env.NODE_ENV === 'development') {
  import('./utils/securityTester').then(({ SecurityTester }) => {
    (window as any).SecurityTester = SecurityTester;
    console.log('🔒 Outils de sécurité chargés. Utilisez SecurityTester.runAllTests() dans la console.');
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
